module.exports = __webpack_public_path__ + "static/media/Instagram.c271a973.svg";